module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/events/events-single-performance/events-single-performance.component.scss
// module id = ./src/app/routes/events/events-single-performance/events-single-performance.component.scss
// module chunks = 9